// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"style_errorMessage__30H_t","invalidUidScreen":"style_invalidUidScreen__3D6pi","invalidUidMessage":"style_invalidUidMessage__34v6u"};